import React from "react";
import { Tooltip } from "antd";
import {
    ExperimentOutlined,
    StarFilled,
    TrophyFilled,
    FireFilled,
    CrownFilled,
} from "@ant-design/icons";
import { getTierStyleByPoints } from "../utils";

// Maps the cross-platform icon names to web (antd) icons.
const ICONS = {
    "seed-outline": ExperimentOutlined,
    "shield-star-outline": StarFilled,
    "trophy-outline": TrophyFilled,
    fire: FireFilled,
    "crown-outline": CrownFilled,
};

// Renders the points value with its tier icon, color, and label.
const PointsTier = ({ points = 0, showLabel = false }) => {
    const tier = getTierStyleByPoints(points);
    const Icon = ICONS[tier.icon] || StarFilled;
    return (
        <Tooltip title={`${tier.label} tier`}>
            <span
                style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 6,
                    color: tier.color,
                    fontWeight: 600,
                }}
            >
                <Icon style={{ fontSize: 16 }} />
                <span style={{ color: "#0f172a" }}>{Number(points) || 0}</span>
                {showLabel && (
                    <span style={{ color: tier.color, fontWeight: 600 }}>
                        {tier.label}
                    </span>
                )}
            </span>
        </Tooltip>
    );
};

export default PointsTier;
